import { useEffect, useRef, useState } from "react";
import { Volume2 } from "lucide-react";
import Reveal from "../Reveal";
import { usePlayer } from "@/contexts/PlayerContext";
import { BRAND_FILM, youtubeEmbed } from "../../data/site";

export const FilmFrame = () => {
  const ref = useRef(null);
  const [near, setNear] = useState(false);
  const { open } = usePlayer();

  useEffect(() => {
    const io = new IntersectionObserver(([e]) => e.isIntersecting && setNear(true), { rootMargin: "300px" });
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  return (
    <section data-testid="film-frame-section" className="bg-black pb-20 md:pb-28 -mt-6 md:-mt-12">
      <div className="container-x">
        <Reveal>
          <div
            ref={ref}
            data-testid="film-frame"
            role="button"
            aria-label="Play the VDYO film with sound"
            onClick={() => open(BRAND_FILM)}
            className="group relative aspect-video overflow-hidden rounded-2xl md:rounded-3xl bg-[#111] ring-1 ring-white/10 hover:ring-[#C8F031]/50 transition duration-300 cursor-pointer shadow-[0_40px_120px_-40px_rgba(200,240,49,0.25)]"
          >
            <img
              src={`/thumbs/${BRAND_FILM.guid}.jpg`}
              alt="VDYO brand film"
              className="absolute inset-0 w-full h-full object-cover"
            />
            {near && (
              <iframe
                data-testid="film-frame-iframe"
                src={youtubeEmbed(BRAND_FILM.youtubeId, { muted: true })}
                title="VDYO — the brand film"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                className="absolute inset-0 w-full h-full border-0 pointer-events-none"
              />
            )}
            <div className="absolute inset-x-0 bottom-0 p-4 md:p-6 flex items-end justify-between gap-4 bg-gradient-to-t from-black/70 to-transparent">
              <p className="hidden sm:block font-heading text-xs md:text-sm font-bold text-white/80">
                <span className="text-[#C8F031] uppercase tracking-[0.2em] text-[10px] md:text-[11px] mr-3">The film</span>
                You shoot it. You send it. We handle the rest.
              </p>
              <span
                data-testid="film-frame-sound-btn"
                className="shrink-0 inline-flex items-center gap-2 rounded-full bg-[#C8F031] text-black font-heading text-xs md:text-sm font-bold px-4 py-2.5 group-hover:bg-[#d8fa55] transition-colors"
              >
                <Volume2 className="w-4 h-4" /> Play with sound · {BRAND_FILM.duration}
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FilmFrame;
